module.exports = __webpack_public_path__ + "static/media/library.c654c797.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/library.svg
// module id = 171
// module chunks = 0